angular.module('zc.zenclerkS')

  .component('zcRealtimeVisitorVisualizer', {
    templateUrl: '/templates/zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.html',
    bindings: {
      project: '<',
      hideSegments: '=',
      hideUsers: '='
    },
    controller($filter, $scope, $q, $timeout, $interval, MongoSession, SegmentMatcher, ZcsSegment, ZcsOemService) {
      const vm = this;
      const SINGLE_FETCH_TIME = 3000;
      const VISUAL_REFRESH_MS = 1000;
      const EXIT_IN_SECONDS = 180;
      const MONITOR_MINUTES = 60 * 24;
      const ROWS = 2;
      const MIN_PER_ROW = 14;

      // keepers for intervals
      let intervalForGetNew;
      let intervalForUpdateExisting;
      let intervalForRemoveCompletely;
      let intervalForVisualUpdate;
      let intervalForSegments;

      let apikey = vm.project.apikey;
      let region = vm.project.region;
      let elementWidth = $('.current-visitor-visualizer').width();
      let elementHeight = $('.current-visitor-visualizer').height();
      let hasStarted = false;
      let maxTime;
      let showPerRow = MIN_PER_ROW;
      let svgContainer;
      let visitorContainer;
      let xScale = 0;
      let yScale = 0;

      vm.ZcsOemService = ZcsOemService;
      vm.sessions = [];
      vm.conversions = [];
      vm.nonConversions = [];
      vm.segments = [];
      vm.segmentCounts = {};

      // actions
      vm.getSegmentLabel = getSegmentLabel;
      vm.getSegmentClass = getSegmentClass;
      vm.getSegmentGAOther = getSegmentGAOther;
      vm.percent2Em = percent2Em;

      vm.$onInit = () => {
        ZcsSegment.all(apikey)
          .then(segments => {
            let promises = _.map(segments, s => ZcsSegment.getLatestStatsForSegment(s.id, apikey));
            $q.all(promises)
              .then(stats => {
                stats = _.flatten(stats);
                vm.segments = _.chain(segments)
                  .map(segment => {
                    segment.stats = _.find(stats, stat => stat.campaign_segment_id === segment.id);
                    if(!segment.stats) {
                      segment.stats = {session_count: 0};
                    }
                    segment.segmentQuery = SegmentMatcher.createSegmentQuery(segment.mongo_query);
                    return segment;
                  })
                  .sortBy(d => -d.stats.session_count)
                  .value();

                // TODO: now initializes here, but should use $onInit
                initializeGraph();
              });
          });

        $scope.$on('$destroy', () => {
          $interval.cancel(intervalForGetNew);
          $interval.cancel(intervalForUpdateExisting);
          $interval.cancel(intervalForRemoveCompletely);
          $interval.cancel(intervalForVisualUpdate);
          $interval.cancel(intervalForSegments);
        });

      };

      function initializeGraph() {

        getInitialVisitors();
        svgContainer = d3.select('.current-visitor-visualizer')
          .append('svg');

        visitorContainer = svgContainer
          .append('g');

        svgContainer
          .attr('width', elementWidth)
          .attr('height', elementHeight);

        createScales();

        intervalForVisualUpdate = $interval(update, VISUAL_REFRESH_MS);
      }


      function getSegmentForSession(session) {
        let hit = 'zcs_segment_all';
        const segmentsToConsider = _.chain(vm.segments)
          .filter(d => isEnabledSegment(d))
          .sortBy(d => -d.stats.session_count)
          .value();
        _.each(segmentsToConsider, segment => {
          const result = SegmentMatcher.matchSessions(segment.segmentQuery, [session]);
          if(!session.segments) { session.segments = ['zcs_segment_all'] }
          if(result.length) {
            session.segments.unshift(segment.name);
            hit = segment.name;
          }
        });
        return hit;
      }

      function calculateSegments() {
        if(!hasStarted) { return }
        let segmentCounts = {};

        const totalCount =
        vm.sessions.length +
        vm.conversions.length +
        vm.nonConversions.length;

        _.each(vm.segments, segment => {
          segmentCounts[segment.name] = _.filter(vm.sessions, d => _.includes(d.segments, segment.name)).length;
          segmentCounts[segment.name] += _.filter(vm.conversions, d => _.includes(d.segments, segment.name)).length;
          segmentCounts[segment.name] += _.filter(vm.nonConversions, d => _.includes(d.segments, segment.name)).length;
        });

        _.each(_.keys(segmentCounts), key => {
          vm.segmentCounts[key] = (segmentCounts[key] / totalCount) * 100;
        });
      }

      function filterExcludedAndSupportStatusSessions(sessions) {
        return _.filter(sessions, d => !d.is_exclude && d.support_status === 'full');
      }

      function getInitialVisitors() {
        let query = {
          apikey: apikey,
          opened_at: { $gte: moment().subtract(MONITOR_MINUTES, 'minutes').valueOf() }
        };

        intervalForGetNew = $interval(getNewVisitors, SINGLE_FETCH_TIME);
        intervalForUpdateExisting = $interval(updateExistingVisitors, SINGLE_FETCH_TIME);
        intervalForRemoveCompletely = $interval(removeCompletelyVisitors, SINGLE_FETCH_TIME);
        intervalForSegments = $interval(calculateSegments, 3000);

        // TODO: ugly, do something better :)
        // get 100 first so that we have something to show instantly
        let promise = MongoSession.find(
          query,
          {
            limit: 100,
            sort: { opened_at: -1 },
            cache: false,
            t: new Date().valueOf()
          }
        )
          .then(res => {
            hasStarted = true;

            if(res.length > 0) {
              maxTime = _.maxBy(res, d => d.opened_at).opened_at;
            } else {
              maxTime = new Date();
            }

            return res;
          })
          .then(handleVisitors);

        promise = _.reduce([200, 200, 200, 200, 200, 200, 200, 200, 300, 1000, 2000, 5000, 10000], (innerPromise, limit) =>
          innerPromise.then(lastTime => {
            if(!lastTime) { return $q.reject() }
            query.opened_at.$lt = $filter('changeDatetimeFrom')('localToRegion', lastTime, 'integer', region);
            return MongoSession.find(query, { limit, sort: { opened_at: -1 }, ignoreLoadingBar: true, cache: false, t: new Date().valueOf() });
          })
            .then(handleVisitors)

          , promise);

        return promise;
      }

      function handleVisitors(res) {
        return $q((resolve, reject) => {
          let sessions = res || [];

          _.each(sessions, session => {
            getSegmentForSession(session);
          });

          sessions = moveEndedToExited(sessions);

          sessions = _.sortBy(sessions, d => d.opened_at);

          // When doing `vm.sessions = xxx`, the visualizer updates and it does
          // not look nice...
          // So unless it's first time, do concat
          if(!vm.sessions.length) {
            vm.sessions = filterExcludedAndSupportStatusSessions(sessions);
          } else {
            vm.sessions.concat(filterExcludedAndSupportStatusSessions(sessions));
          }

          calculateSegments();
          if(!res.length) { return reject(undefined) }
          return resolve(_.last(res).opened_at);
        });
      }


      function isEnabledSegment(segment) {
        return ['zcs_segment_new', 'zcs_segment_cv_users', 'zcs_segment_all'].indexOf(segment.name) >= 0;
      }

      function getSegmentClass(segmentName) {
        if(!segmentName) {
          return 'zcs-segment-all';
        }
        return segmentName.replace(/_/g, '-');
      }

      function getSegmentLabel(segment) {
        return ZcsSegment.getSegmentLabel(segment.name);
      }

      // TBF! This returns the other Google Analytics Segment.. I guess
      function getSegmentGAOther() {
        return vm.segmentCounts.zcs_segment_all - vm.segmentCounts.zcs_segment_ga_new;
      }

      function getNewVisitors() {
        if(!hasStarted) { return }
        const query = {
          apikey: apikey,
          opened_at: { $gt: maxTime }
        };

        MongoSession.find(query, { limit: 10000, cache: false, t: new Date().valueOf(), ignoreLoadingBar: true })
          .then(newSessions => {
            if(!newSessions || !newSessions.length) { return }

            newSessions = filterExcludedAndSupportStatusSessions(newSessions);
            _.each(newSessions, newSession => {
              if(_.some(vm.sessions, session => session._id === newSession._id)) return;
              const pushDelay = Math.random() * SINGLE_FETCH_TIME;
              getSegmentForSession(newSession);
              $timeout(() => {
                vm.sessions.push(newSession);
              }, pushDelay);
            });

            // Update open time only if there are new sessions
            if(newSessions.length) {
              maxTime = _.maxBy(newSessions, d => d.opened_at).opened_at;
            }
          });
      }

      function updateExistingVisitors() {
        if(!hasStarted) { return }
        const ids = _.map(vm.sessions, d => d._id);
        const idChunks = _.chunk(ids, 50);

        _.each(idChunks, idsInChunk => {
          const updateExistingQuery = {
            apikey: apikey,
            _id: { $in: idsInChunk }
          };

          MongoSession.find(updateExistingQuery, { limit: 10000, cache: false, t: new Date().valueOf(), ignoreLoadingBar: true })
            .then(existingSessions => {
              mergeSessions(existingSessions, vm.sessions);
              vm.sessions = moveEndedToExited(vm.sessions);
            });
        }
        );
      }

      function removeCompletelyVisitors() {
        if(!hasStarted) { return }
        vm.nonConversions = removeCompletely(vm.nonConversions);
      }


      function mergeSessions(fromSessions, toSessions) {
        _.each(fromSessions, d => {
          const idx = _.findIndex(toSessions, s => s._id === d._id);
          if(idx) {
            toSessions[idx] = _.assignIn(toSessions[idx], d);
          }
        });
      }

      function moveEndedToExited(sessions) {
        const momentNow = $filter('changeDatetimeFrom')('regionToLocal', new Date(), 'moment', region);
        const sessionsToBeRemoved = _.filter(sessions, (d, i) => {
          const secondsFromClose = momentNow.diff(moment(d.closed_at), 'seconds');
          return d.closed_at !== null &&
           secondsFromClose > EXIT_IN_SECONDS;
        });

        const afterRemovalSessions = _.reject(sessions, (d, i) => _.includes(sessionsToBeRemoved, d));

        // push to past conversions also
        _.each(sessionsToBeRemoved, d => {
          if(d.conversion_count > 0) {
            vm.conversions.push(d);
          } else {
            vm.nonConversions.push(d);
          }
        });

        return afterRemovalSessions;
      }

      function removeCompletely(sessions) {
        const momentNow = $filter('changeDatetimeFrom')('regionToLocal', new Date(), 'moment', region);
        return _.filter(sessions, d => d.closed_at === null || momentNow.diff(moment(d.closed_at), 'minutes') < MONITOR_MINUTES);
      }

      function createScales() {
        showPerRow = d3.max([Math.ceil(vm.sessions.length / ROWS), MIN_PER_ROW]);
        xScale = d3.scale.linear()
          .domain([0, showPerRow])
          .rangeRound([0, elementWidth]);
        yScale = d3.scale.linear()
          .domain([0, ROWS])
          .range([0, elementHeight]);
      }

      function update() {
        createScales();

        const visitor = visitorContainer.selectAll('.visitor')
          .data(vm.sessions, d => d._id);

        // exit
        visitor
          .exit()
          .transition('exit')
          .duration(VISUAL_REFRESH_MS / 2)
          .attr('transform', (d, i) => 'scale(0)'
          );

        // enter
        visitor
          .enter()
          .append('g')
          .attr('class', d => `visitor ${getSegmentClass(d.segments[0])}-fill`)
          .attr('data-usid', d => d._id)
          .append('path')
          .attr('d', 'M28.4108527,31.2693483 C31.53832,28.7662087 33.7466252,24.0221674 33.7466252,20.25 C33.7466252,14.8652237 32.2466252,9 23.9966252,9 C15.7466252,9 14.2466252,14.8652237 14.2466252,20.25 C14.2466252,24.029553 16.4635863,28.7847893 19.6007783,31.2840254 C15.3931617,32.1120234 10.8619795,33.6113023 10.8619795,33.6113023 C9.27149834,34.0951213 7.78742498,35.8273335 7.53817454,37.4646824 L7,41 C7,41 14.0104863,48 24.0052432,48 C34,48 41,41 41,41 L40.4675289,37.4646824 C40.2214808,35.831057 38.7424525,34.099987 37.1652794,33.6065459 C37.1652794,33.6065459 32.6584573,32.0929905 28.4108527,31.2693483 Z')
          .attr('stroke', '#fff')
          .attr('stroke-opacity', 0.5)
          .attr('stroke-position', 'outside')
          .attr('stroke-width', '1px')
          .attr('opacity', setVisitorOpacity)
          .attr('transform', 'scale(0)')
          .transition('enter')
          .duration(VISUAL_REFRESH_MS / 2)
          .attr('transform', (d, i) => 'scale(1)');
        // update
        visitor.transition()
          .duration(VISUAL_REFRESH_MS / 2)
          .attr('opacity', setVisitorOpacity)
          .attr('transform', function(d, i) {
            const y = yScale(Math.floor(i / showPerRow));
            const x = xScale(i - (showPerRow * Math.floor(i / showPerRow)));
            return `translate(${x}, ${y})`;
          });
      }


      function setVisitorOpacity(d) {
        let opacity = 1;
        if(d.closed_at !== null) {
          opacity = d3.min(1, 0.2 + (moment().diff(moment(d.closed_at), 'seconds') / EXIT_IN_SECONDS));
        }
        return opacity;
      }

      //# Scale a percentage to a Css element size
      function percent2Em(percent) {
        const scaleSize = 35; // reduce the original percentage
        const scaleMin = 0.8; // minimum size
        const size = (percent / scaleSize) + scaleMin;
        return `${size.toFixed(1)}em`;
      }

    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.js